const GET_AZURE_DASHBOARD_DETAILS = "GET_AZURE_DASHBOARD_DETAILS";
const GET_AZURE_DASHBOARD_DETAILS_SUCCESS =
  "GET_AZURE_DASHBOARD_DETAILS_SUCCESS";
const GET_AZURE_DASHBOARD_DETAILS_ERROR = "GET_AZURE_DASHBOARD_DETAILS_ERROR";

const GET_AZURE_DASHBOARD_SERVICES_DETAILS =
  "GET_AZURE_DASHBOARD_SERVICES_DETAILS";
const GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS =
  "GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS";
const GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR =
  "GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR";

const GET_FORECAST_BILL_AZURE = "GET_FORECAST_BILL_AZURE";
const GET_FORECAST_BILL_AZURE_SUCCESS = "GET_FORECAST_AZURE_BILL_SUCCESS";
const GET_FORECAST_BILL_AZURE_ERROR = "GET_FORECAST_AZURE_BILL_ERROR";

const GET_RESOURCE_GROUP_NAME = "GET_RESOURCE_GROUP_NAME";
const GET_RESOURCE_GROUP_NAME_SUCCESS = "GET_RESOURCE_GROUP_NAME_SUCCESS";
const GET_RESOURCE_GROUP_NAME_ERROR = "GET_RESOURCE_GROUP_NAME_ERROR";

const GET_DAILY_FORECAST_BILL_AZURE = "GET_DAILY_FORECAST_BILL_AZURE";
const GET_DAILY_FORECAST_BILL_AZURE_SUCCESS =
  "GET_DAILY_FORECAST_AZURE_BILL_SUCCESS";
const GET_DAILY_FORECAST_BILL_AZURE_ERROR =
  "GET_DAILY_FORECAST_AZURE_BILL_ERROR";
const GET_LOCATION_FORECAST_BILL_AZURE = "GET_LOCATION_FORECAST_BILL_AZURE";

export {
  GET_AZURE_DASHBOARD_DETAILS,
  GET_LOCATION_FORECAST_BILL_AZURE,
  GET_AZURE_DASHBOARD_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_DETAILS_ERROR,
  GET_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_SUCCESS,
  GET_AZURE_DASHBOARD_SERVICES_DETAILS_ERROR,
  GET_RESOURCE_GROUP_NAME,
  GET_RESOURCE_GROUP_NAME_SUCCESS,
  GET_RESOURCE_GROUP_NAME_ERROR,
};
